// 2) Third-party libraries
import { call, delay } from "redux-saga/effects";
import { DocumentNode } from "graphql";
import { get } from "lodash-es";

// 3) Local imports
// 3.1 Constants
import { maxAPIRefetchCount, refetchAPIDelay } from "src/config/config";

// 3.3 Project-specific modules � components/types/other
import client from "src/api";

// 3.4 Utility functions / types
import { DynamicObject } from "./commonInterfaces";
import { getNewHeaderKeyForCustomerPortal } from "./commonFunctions";

export function* graphqlCallWithRetry(
	query: DocumentNode,
    variables: any,
	dataPath: string,
    customerId?: string,
    maxRetries: number = maxAPIRefetchCount,
    delayMs: number = refetchAPIDelay
) {
	for (let i = 0; i < maxRetries; i++) {
        try {
            const res: DynamicObject = yield call(
                [client, client.graphql],
                {
                    query,
                    variables
                },
                getNewHeaderKeyForCustomerPortal(customerId)
            );

            return get(res, dataPath);
        } catch (err) {
            if (i < maxRetries - 1) {
                yield delay(delayMs);
            }
        }
    }

    throw new Error('Failed to fetch data after multiple attempts.');
}